import { render } from "./period.vue?vue&type=template&id=79206dca&scoped=true"
import script from "./period.vue?vue&type=script&lang=js"
export * from "./period.vue?vue&type=script&lang=js"

import "./period.vue?vue&type=style&index=0&id=79206dca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79206dca"]])

export default __exports__